// The one escapeHtml, importable from anywhere — including under node --test.
//
// There were eight copies of this function (#76): map.ts, live.ts, panels.ts,
// no-webgl.ts, sparkline.ts, search-ui.ts, fubar-page.ts and status-page.ts
// each held their own — the review that filed #76 counted six, and the guard
// in scripts/test-escape.mjs found the other two on its first run. The copies
// were not vanity — the exported ones lived in modules whose load touches
// `import.meta.env`, a Vite substitution that is undefined under `node --test`,
// so any Node-tested module had to carry its own rather than import one.
// no-webgl.ts said exactly that above its copy, and it was right.
//
// This module is the answer to that constraint rather than a ninth copy: it
// imports NOTHING, touches no environment, and must stay that way — one
// import added here and every Node-run test of a module that escapes text
// stops loading. That property is what lets all six call sites share one
// definition of the one helper it is dangerous to let drift.
//
// scripts/test-escape.mjs holds both halves: the behaviour, and that this is
// the only definition in the tree.

/**
 * Text into markup, for every template string that renders feed data.
 *
 * Accepts unknown rather than string because half the callers hold a value
 * off the wire, and `String(null)` printing "null" into a card is a smaller
 * failure than a type assertion that lies.
 */
export function escapeHtml(s: unknown): string {
  return String(s ?? '').replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
}
